export default class empresa{
	constructor($scope,
				$routeParams,
				method,
				empresasService,
				$location,
                $uibModal,
				toastr
				){
		this.scope    = $scope;
		this.location = $location;
		this.toastr = toastr;
        this.modal = $uibModal;
		switch (method) {
			case 'list':
				this.list(empresasService);
			break;
			case 'new':
				this.create(empresasService);
			break;
			case 'view':
				this.view($routeParams,
                    empresasService);
			break;
		}
	}

	list(empresasService){

        let self = this.scope;
        empresasService.getAll().then((resp, err) => {
			self.empresas = resp.data.message;
		});

        self.getItemPage = (item) => {
            let index = self.empresas.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, empresasService);

        /*this.scope.inAction = false;
		this.scope.eliminar = (id, index) => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                empresasService.delete({_id: id}).then((resp) => {
                    if (resp.data.success == true) {
                        this.toastr.success('Empresa eliminada correctamente!', 'Success!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        window.location.reload();
                    }
                })
				.catch((err) => {
                    this.scope.inAction = false;
					this.toastr.error('Error', 'Error al eliminar la empresa!', {
						timeOut: 2000,
						closeButton: true
					});
				});
            }
		};*/
	}

	create(empresasService){

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                empresasService.save(this.scope.empresa).then((resp) => {
                    this.toastr.success('Empresa creada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/empresa');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al crear la empresa!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};
	}

	view($routeParams,
         empresasService){

		this.scope.aux = {};
        empresasService.getById({_id: $routeParams.id}).then((resp) => {
			this.scope.empresa = resp.data.message;
		}).catch((er) => {
			console.log(er);
		});

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                empresasService.update(this.scope.empresa).then((resp) => {
                    this.toastr.success('Empresa modificada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/empresa');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al modificar la empresa!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
		};
	}

    eliminar(service,object, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Empresa</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar la empresa: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = object.nombre;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.delete({_id: object._id}).then((resp) => {
                    self.scope.empresas.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Empresa eliminada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error('Error al eliminar la empresa!','Error',  {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}


// WEBPACK FOOTER //
// ./app/js/controllers/empresa/empresa.js